<template>
  <el-container class="container wh100p df-l-fs">

    <el-header class="header df w100p">
      <!-- icon与文字切换 -->
      <!-- <div class="system-name f-white df-l-c-ct" @click="toggleCollapse">
        <div class="transition" :style="isCollapse?'width: 64px;':'width: 180px;'" >
          <template v-if="isCollapse">
            <img style="width:18px;height:18px;" src="@/assets/icons/more.png">
          </template>
          <template v-else>
            <div>{{shop_x.companyName}}</div>
            <div>{{shop_x.name}}</div>
          </template>
        </div>
      </div> -->
      <div class="system-name f-white df-l-c-ct" @click="toggleCollapse">
        <div class="transition" style="width: 64px;" >
          <img style="width:18px;height:18px;" src="@/assets/icons/more.png">
        </div>
      </div>
      <!-- icon与文字切换 -->
      <div class="df-c-sb f1" style="">
        <!-- 左侧 -->
        <ul class="df-c-fs">
          <!-- 语言 -->
          <li v-if="canChangeLang">
            <el-popover placement="top" width="150" v-model="visibleLang">
              <div class="popper-content">
                <div class="item f-xxs _c5" :class="{'ac':x.value===$i18n.locale}" v-for="(x,i) in languages" :key="i" @click="languageChange(x.value)">{{x.label}}</div>
              </div>
              <div slot="reference" class="popper-btn plr10 _cf df-c-fs">
                <div class="f-xxs">{{currentLangName}}</div>
                <i class="el-icon-arrow-down popper-icon transition" :class="{'rotate-180':visibleLang}"></i>
              </div>
            </el-popover>
          </li>
          <li v-else>
            <div class="pl10 pr30 _cf f-xxs">{{currentLangName}}</div>
          </li>
          <!-- 营业状态 -->
          <li class="f-xxs f-white" style="margin:20px 20px 20px 0;">{{shop_x.businessStatus?$t('index.inBusiness'):$t('index.outBusiness')}}</li>
          <!-- 已营业 设备状态 -->
          <template v-if="shop_x.businessStatus">
            <el-popover placement="top" width="520" v-model="visiblePrinter" trigger="manual" @show="popoverShow">
              <div class="popper-printer">
                <!-- 触摸屏 -->
                <div class="part df" v-if="monitorList.length">
                  <div class="label df-c-ct f-s">{{$t('index.monitor')}}</div>
                  <div class="items df-w-c-fs">
                    <div class="item df-l-c-ct" v-for="(x,i) in monitorList" :key="i">
                      <!-- <img class="close-btn rotate45" src="@/assets/icons/cross.png" v-if="!x.online" @click="delMonitor(x,i)"> -->
                      <img class="close-btn rotate45" src="@/assets/icons/cross.png" @click="delMonitor(x,i)">
                      <img style="width:24px;height:24px;margin-bottom:6px;" src="@/assets/icons/devices/monitor.svg">
                      <div class="w100p tac ellipsis-s" :style="UUID===x.uuid?'color:transparent;':''">{{x.showIndex}}</div>
                      <div class="w100p df-c-sa f-xxxs">
                        <div class="tip1 _redcolor" v-if="UUID===x.uuid&&!networkStatus_x">{{$t('index.linkFail')}}</div>
                        <div class="tip1 _greencolor" v-else-if="x.online">{{$t('index.linkOk')}}</div>
                        <div class="tip1 _redcolor" v-else>{{$t('index.linkFail')}}</div>
                      </div>
                      <el-tag class="tip0" v-if="UUID===x.uuid">{{$t('index.thisOne')}}</el-tag>
                      <!-- <div class="tip0" v-if="UUID===x.uuid">{{$t('index.thisOne')}}</div> -->
                    </div>
                  </div>
                </div>
                <!-- 打印机 -->
                <div class="part _bordertop df" v-if="printerList.length">
                  <div class="label df-c-ct f-s">{{$t('index.printer')}}</div>
                  <div class="items df-w-c-fs">
                    <div
                      class="item df-l-c-ct" v-for="(x,i) in printerList" :key="i"
                      :class="{'item-ac':x.id===printerId_x}"
                      @click="x.printerType===1&&printerSelect(x,i)">
                      <img style="width:24px;height:24px;margin-bottom:6px;" src="@/assets/icons/devices/printer.svg" v-if="x.printerType===1">
                      <img style="width:24px;height:24px;margin-bottom:6px;" src="@/assets/icons/devices/printer2.svg" v-else-if="x.printerType===0">
                      <div class="w100p tac ellipsis-s">{{x.name}}</div>
                      <div class="w100p df-c-sa f-xxxs">
                        <div class="tip1 _greencolor" v-if="x.status===1">{{$t('index.linkOk')}}</div>
                        <div class="tip1 _redcolor" v-else-if="x.status===2">{{$t('index.linkError')}}</div>
                        <div class="tip1 _redcolor" v-else-if="x.status===3">{{$t('index.linkFail')}}</div>
                        <!-- <div class="tip2">延迟报错</div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- POS机 -->
                <div class="part _bordertop df" v-if="readerList.length">
                  <div class="label df-c-ct f-s">{{$t('index.reader')}}</div>
                  <div class="items df-w-c-fs">
                    <div
                      class="item df-l-c-ct" v-for="(x,i) in readerList" :key="i"
                      :class="{'item-ac':x.ipAdress===readerId_x}"
                      @click="readerSelect(x,i)"
                      v-if="sysEnv_x==='hk'">
                      <img style="width:24px;height:24px;margin-bottom:6px;" src="@/assets/icons/devices/pos-terminal.svg">
                      <div class="w100p tac ellipsis-s">{{x.terminalName}}</div>
                    </div>
                    <div
                      class="item df-l-c-ct" v-for="(x,i) in readerList" :key="'a'+i"
                      :class="{'item-ac':x.stripeId===readerId_x}"
                      @click="readerSelect(x,i)"
                      v-else-if="sysEnv_x==='us'">
                      <img style="width:24px;height:24px;margin-bottom:6px;" src="@/assets/icons/devices/pos-terminal.svg">
                      <div class="w100p tac ellipsis-s">{{x.label}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="reference" class="_cf f-xxs df-c-fs" @click="visiblePrinter=!visiblePrinter">
                <img style="width:20px;height:20px;margin-right:10px;" :src="isGreenLight?iconbulbok:iconbulberror">
                <div class="pr10">{{$t('index.deviceStatus')}}</div>
                <i class="el-icon-arrow-down popper-icon transition" :class="{'rotate-180':visiblePrinter}"></i>
              </div>
            </el-popover>
          </template>
          <!-- 未营业 开店 -->
          <!-- <template v-else>
            <div class="whitebtn-s" style="margin-left:20px;" :style="lang==='en'?'font-size:14px;':''" @click="openShopClick">{{$t('index.startBusiness')}}</div>
          </template> -->
          <!-- 场景 -->
          <li class="df-c-fs" style="margin-left:30px;" @click="popoverClick">
            <div class="f-white f-xxs">{{$t('index.currentScene')}}：</div>
            <el-popover placement="top" width="170" v-model="visibleScene" :disabled="popoverDisabled" >
              <div class="popper-content">
                <div class="item f-xxs _c5" :class="{'ac':x.id===sceneId}" v-for="(x,i) in scenes" :key="i" @click="sceneChange(x.id)">{{x.name}}</div>
              </div>
              <div slot="reference" class="popper-btn plr10 _cf df-c-fs">
                <div class="f-xxs">{{currentSceneName}}</div>
                <i class="el-icon-arrow-down popper-icon transition" :class="{'rotate-180':visibleScene}"></i>
              </div>
            </el-popover>
          </li>
        </ul>
        <!-- 中间 -->
        <ul class="df-c-fs f1">
          <li class="ml20">
            <img class="logo" src="@/assets/images/logo-pure-white.svg" @click="navToHome">
          </li>
        </ul>
        <!-- 右侧 -->
        <ul class="df-c-fs">
          <li class="mr20" v-if="user_x.privilegeList&&user_x.privilegeList.includes('sjzhgl_bdxjgl')" @click="openCashDrawer">
            <div class="whitebtn-s mr20">
              <div class="df-c-sa">
                <img style="width:24px;height:24px;" src="@/assets/icons/cashdrawer.svg">
                <span>{{$t('index.cash1')}}</span>
              </div>
            </div>
            <!-- <div class="whitebtn-s mr20" :style="lang==='en'?'font-size:14px;':''" @click="openCashDrawer">{{$t('index.cash')}}</div> -->
          </li>
          <!-- 账号昵称 -->
          <template v-if="isShowWaiterModel&&waiter_x&&waiter_x.id">
            <li class="nickname mr20 f-xxs f-white">{{waiter_x.nickName}}</li>
          </template>
          <template v-else>
            <li class="nickname mr20 f-xxs f-white">{{user_x.nickName}}</li>
          </template>
          <!-- 账号头像 -->
          <img class="avatar circle" :src="(shop_x.shopImg||user_x.imgId)|toimg" v-if="shop_x.shopImg||user_x.imgId">
          <img class="avatar" :src="''|toimg" v-else>
          <!-- 账号更多设置 -->
          <el-popover placement="top" width="170" v-model="visibleUser">
            <div class="popper-content">
              <div class="item f-xxs _c5" @click="toggloFullScreen" v-if="isShowFullBtn">{{full_screen?$t('index.toggloFullScreen_true'):$t('index.toggloFullScreen_false')}}</div>
              <div class="item f-xxs _c5" @click="openDialogDate" v-if="isShowDateBtn">{{$t('index.dateControl')}}</div>
              <div class="item f-xxs _c5" @click="navToFeedback">{{$t('index.myFeedback')}}</div>
              <div class="item f-xxs _c5" @click="navToLock" v-if="isShowWaiterModel">{{$t('index.lock')}}</div>
              <div class="item f-xxs _c5" @click="logout">{{$t('index.logout')}}</div>
            </div>
            <div slot="reference" class="popper-btn popper-btn-user _cf df-c-fs">
              <div class="f-xxs">{{shop_x['name'+_lang]}}</div>
              <i class="el-icon-arrow-down popper-icon transition" :class="{'rotate-180':visibleUser}"></i>
            </div>
          </el-popover>
        </ul>
      </div>
    </el-header>

    <section class="content df f1">

      <el-aside :width="asideWidth" class="transition">
        <el-menu
          ref="menu"
          class="el-menu-vertical-demo"
          :default-active="currentRoute"
          background-color="#374978"
          active-background-color="#5F6D93"
          text-color="#fff"
          active-text-color="#fff"
          :collapse="isCollapse"
          @select="menuSelect">
          <!-- mode="horizontal" -->

          <el-menu-item v-for="(x,i) in menus" :key="i" :index="x.route" :route="x.route==='member'?'':x.route">
            <div v-if="isCollapse">
              <el-badge class="dot" :value="
                (x.key==='items'&&menuCount_x.itemsSellOutCount>0?menuCount_x.itemsSellOutCount:'')
                ||(x.key==='orderNew'&&menuCount_x.waitingOrderCount>0?menuCount_x.waitingOrderCount:'')
                ||(x.key==='book'&&menuCount_x.waitingBookCount>0?menuCount_x.waitingBookCount:'')
              ">
                <img :src="x.img" style="width:24px;height:24px;">
              </el-badge>
              <span slot="title" style="margin-left:12px;">{{$t('index.'+x.key)}}</span>
            </div>
            <div v-else>
              <img :src="x.img" style="width:24px;height:24px;color:#fff;fill:#fff;">
              <span
                slot="title" style="margin-left:12px;"
                :data-num="
                  (x.key==='items'&&menuCount_x.itemsSellOutCount>0?menuCount_x.itemsSellOutCount:'')
                  ||(x.key==='orderNew'&&menuCount_x.waitingOrderCount>0?menuCount_x.waitingOrderCount:'')
                  ||(x.key==='book'&&menuCount_x.waitingBookCount>0?menuCount_x.waitingBookCount:'')
                "
                :class="{'red-dot1':
                  (x.key==='items'&&menuCount_x.itemsSellOutCount>0)
                  ||(x.key==='orderNew'&&menuCount_x.waitingOrderCount>0)
                  ||(x.key==='book'&&menuCount_x.waitingBookCount>0)
                }">{{$t('index.'+x.key)}}</span>
            </div>
          </el-menu-item>

        </el-menu>
        <!-- <div class="el-radio-group">
          <div class="toggle-aside-style-btn" v-show="isCollapse" @click="isCollapse=!isCollapse"><i class="el-icon-arrow-right"></i></div>
          <div class="toggle-aside-style-btn" v-show="!isCollapse" @click="isCollapse=!isCollapse"><i class="el-icon-arrow-left"></i></div>
        </div> -->
        <div class="bell-box" @click="bellClick">
          <img class="bell" src="@/assets/images/ring-bell.svg">
        </div>
        <div class="feedback-box">
          <div class="feedback-btn f-xs" :class="{'feedback-btn-collapse':isCollapse}" @click="createFeedback">{{$t('index.feedback')}}</div>
        </div>
      </el-aside>

      <el-main>
        <div class="tip-error w100p df-c-sb transition" :class="{'tip-error-show':isShowTip}">
          <!-- v-show="isShowTip" -->
          <div>{{$t('print.printerError')}}</div>
          <div class="df-c-ct" @click="viewDeviceError">
            <div>{{$t('index.viewDetail')}}</div>
            <div class="ml20">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
        <!-- <Tab /> -->

        <!-- <keep-alive exclude="calcway"> -->

        <div class="wh100p" :class="{'shorter':isShowTip}">
          <!-- <div>scan_code：{{scan_code_}}</div>
          <div>scan_result：{{scan_result_}}</div> -->
          <keep-alive>
            <router-view ref="child" />
          </keep-alive>
        </div>
      </el-main>
    </section>

    <DialogSellout ref="DialogSellout" />

    <DialogKey ref="DialogKey" />

    <DialogDriveError ref="DialogDriveError" @getStatus="getStatus" />

    <DialogFeedback ref="DialogFeedback" />

    <DialogDateControl ref="DialogDateControl" />

    <DialogMember ref="DialogMember" showOpenBtn :showBindBtn="showBindBtn" @submitDialog="submitDialogMember" />

    <DialogCouponSelect ref="DialogCouponSelect" @select="submitDialogCouponSelect" @submitDialog="submitDialogCouponSelect" />

    <DialogCashDrawer ref="DialogCashDrawer" />

    <!-- <EasyRing :open="bellOpen_x" :ring="bellRing_x" :src="require('@/assets/music/bell.mp3')" /> -->

  </el-container>
</template>

<script>
import { mapMutations } from 'vuex'
import DialogSellout from '@/components/DialogSellout'
import DialogDriveError from './components/DialogDriveError'
import DialogFeedback from './components/DialogFeedback'
import DialogMember from './components/DialogMember'
import DialogCouponSelect from './components/DialogCouponSelect'
import DialogCashDrawer from './components/DialogCashDrawer'
import DialogDateControl from './components/DialogDateControl'
import mixin_fullScreen from '@/mixins/mixin_fullScreen'
import mixin_webSocket from '@/mixins/mixin_webSocket'
import scan from '@/mixins/scan'
// import EasyRing from 'easy-ring'
// import { EasyRingVueComponent as EasyRing } from 'easy-ring'
export default {
  name: 'index',
  mixins: [mixin_fullScreen, mixin_webSocket, scan],
  // components: { DialogSellout, DialogDriveError, DialogFeedback, DialogMember, DialogCouponSelect, EasyRing },
  components: { DialogSellout, DialogDriveError, DialogFeedback, DialogMember, DialogCouponSelect, DialogCashDrawer, DialogDateControl },
  data() {
    return {
      iconbulbok: require('@/assets/icons/bulbok.png'), // 设备状态 绿灯
      iconbulberror: require('@/assets/icons/bulberror.png'), // 设备状态 红灯
      // menus: [],
      menus: [
        {key:'home',route:'table',img:require('@/assets/icons/menu1.png')}, // 餐桌
        // {key:'menu',route:'menu',img:require('@/assets/icons/menu2.png')}, // 菜单
        {key:'lineup',route:'lineup',img:require('@/assets/icons/menu2.png')}, // 排队管理
        {key:'order',route:'order',img:require('@/assets/icons/menu3.png')}, // 订单管理
        // {key:'items',route:'items',img:require('@/assets/icons/menu4.png')}, // 菜品管理
        // {key:'shop',route:'shop',img:require('@/assets/icons/menu5.png')}, // 店铺营业状态
        // {key:'takeaway',route:'takeaway',img:require('@/assets/icons/menu6.png')}, // 外卖平台
        // {key:'qrcode',route:'qrcode',img:require('@/assets/icons/menu7.png')}, // 二维码管理
        // {key:'orderNew',route:'orderNew',img:require('@/assets/icons/menu8.png')}, // 落单审核
        // {key:'book',route:'book',img:require('@/assets/icons/menu10.svg')}, // 预定管理
        // {key:'member',route:'member',img:require('@/assets/icons/menu9.png')}, // 会员管理
      ], // 菜单列表
      language: 'zh', // 当前语言
      languages: [
        {label:'繁體中文',value:'zh'},
        {label:'English',value:'en'},
      ], // 语言选项
      printerList: [], // 打印机列表
      monitorList: [], // 触摸屏列表
      readerList: [], // POS机列表
      sceneId: '', // 场景ID
      scenes: [], // 场景列表
      isSceneChangeByUser: false,

      isGreenLight: true,
      isShowTip: false,

      visibleLang: false, // 语言开关 控制扩展窗口开合
      visiblePrinter: false, // 设备状态开关 控制扩展窗口开合
      visibleScene: false, // 场景开关 控制扩展窗口开合
      visibleUser: false, // 用戶信息开关
      isCollapse: false, // 菜单开关1
      isCollapse_secondSwitch: true, // 菜单开关2

      timer: null,
      UUID: '',
      isShowFullBtn: true,

      showBindBtn: false,
      orderBindCustomerCallback: null,
      orderBindCustomerCouponCallback: null,
    }
  },
  computed: {
    asideWidth() {
      if (this.currentRoute === 'menu' && this.isCollapse_secondSwitch) {
        return '0'
      } else {
        return this.isCollapse ? '64px' : '180px'
      }
    },
    canChangeLang() {
      // console.log(`%c语言模式:`, 'color: #f00;', this.shop_x.langInt)
      switch (this.shop_x.langInt) {
        case 0:
          return true
        case 1:
          this.$i18n.locale = 'zh'
          localStorage.setItem('dola_b_language', 'zh')
          return false
        case 2:
          this.$i18n.locale = 'en'
          localStorage.setItem('dola_b_language', 'en')
          return false
      }
    },
    currentLangName() {
      const ITEM = this.languages.find(x => x.value === this.lang)
      if (ITEM) {
        return ITEM.label
      }
      return languages[0].label
    },
    currentSceneName() {
      const ITEM = this.scenes.find(x => x.id === this.sceneId)
      if (ITEM) {
        return ITEM.name
      }
      return this.$t('index.noScene')
    },
    popoverDisabled() {
      if (this.shop_x.sceneAsMenu && this.currentRoute === 'menu') {
        // this.$message.warning('场景餐桌化点餐时，不允许场景切换')
        return true
      }
      return false
    },
    
    // #region 是否显示手动日期控制
    isShowDateBtn() {
      return this.user_x && this.user_x.privilegeList && this.user_x.privilegeList.includes('sjzhgl_bdsdqrkz')
    },
    // #endregion
  },
  watch: {
    currentRoute(n, o) {
      if (n === 'menu') {
        this.isCollapse_secondSwitch = true
      } else {
        this.isSceneChangeByUser = false
      }
    },
  },
  provide() {
    return {
      orderBindCustomer: options => {
        this.showBindBtn = true
        this.orderBindCustomerCallback = options.callback
        this.$refs.DialogMember.open(options.orderId)
      },
      orderBindCustomerCoupon: options => {
        this.orderBindCustomerCouponCallback = options.callback
        this.$refs.DialogCouponSelect.open(options.coupons)
      },
      itemsSellOutSearch: this.itemsSellOutSearch,
      waitingOrderSearch: this.waitingOrderSearch,
      waitingBookSearch: this.waitingBookSearch,
    }
  },
  methods: {
    ...mapMutations(['paytypes_x_save', 'paytypes2_x_save']),
    submitDialogMember(result) {
      // console.log(`%c优惠券 result:`, 'color: #f00;', result)
      this.orderBindCustomerCallback(result)
    },
    submitDialogCouponSelect(result) {
      // console.log(`%c勾选的优惠券 result:`, 'color: #f00;', result)
      this.orderBindCustomerCouponCallback(result)
    },
    ...mapMutations([
      'user_x_save',
      'user_x_clear',
      'sceneId_x_save',
      'modelList_x_save',
      'printerId_x_save',
      'readerId_x_save',
      'homePage_x_save'
    ]),
    menuSelect(index, indexPath) {
      // console.log(`%c菜单激活项:`, 'color: #f00;', index, indexPath)
      if (index === 'member') {
        this.showBindBtn = false
        this.$refs.DialogMember.open()
      } else if (index === 'shop') {
        if (this.user_x.privilegeList.includes('sjzhgl_bddpztmmbh')) {
          this.$router.push(index)
        } else {
          this.$refs.DialogKey.open({
            onConfirm: () => {
              this.$router.push('shop')
            }
          })
        }
      } else if (index === 'order') {
        this.$router.push(`${index}?refresh=true`)
      } else {
        this.$router.push(index)
      }
      switch (index) {
        case 'menu':
        case 'table':
          this.getCurrentScene()
          break;
      }
    },

    // 切换菜单縮放
    toggleCollapse() {
      if (this.currentRoute === 'menu') {
        this.isCollapse_secondSwitch = !this.isCollapse_secondSwitch
      } else {
        this.isCollapse = !this.isCollapse
      }
    },
    // 打开我的反馈
    createFeedback() {
      this.$refs.DialogFeedback.open()
    },
    // 查看设备报错
    viewDeviceError() {
      this.$refs.DialogDriveError.open()
    },
    getStatus(res) {
      this.isGreenLight = res.isGreenLight
      this.isShowTip = res.isShowTip
    },

    popoverShow() {
      // 获取 打印机
      this.getPrinter()
      // 获取 触摸屏
      this.getMonitor()
      // 获取 POS机
      this.getReader()
    },
    
    // 开店 需要输入密匙
    // openShopClick() {
    //   this.$refs.DialogKey.open({
    //     onConfirm: this.openShop
    //   })
    // },
    // 开始营业
    // async openShop() {
    //   const _D = await this.setData('shop', {
    //     id: this.currentShopId,
    //     businessStatus: true,
    //   })
    //   if (_D === 'ok') {
    //     let shopData = JSON.parse(JSON.stringify(this.shop_x))
    //     shopData.businessStatus = true
    //     this.shop_x_save(shopData)
    //     this.$refs.DialogSellout.checkSellOut()
    //   }
    // },

    // 语言切换
    languageChange(val) {
      this.$i18n.locale = val
      localStorage.setItem('dola_b_language', val)
      this.visibleLang = false
    },
    // 场景切换 需要输入密匙
    sceneChange(id) {
      this.isSceneChangeByUser = true
      this.initScene(id)
    },
    popoverClick() {
      if (this.popoverDisabled) {
        this.$message.warning(this.$t('menu.sceneChangeWarning'))
      }
    },
    // 打印机选择
    printerSelect(item, index) {
      // console.log(`%cprinterId_x:`, 'color: #f00;', this.printer_x, this.shop_x.id, this.printer_x[this.shop_x.id], this.printerId_x)
      // console.log(`%c选择的打印机:`, 'color: #f00;', item, item.location, item.id)
      // if (item.status === 1) {
        this.printer_x[String(this.shop_x.id)] = item.id
        this.printerId_x_save(JSON.parse(JSON.stringify(this.printer_x)))
        // this.printerId_x_save(item.id)
        this.$api.print_change({ printerId: item.id })
      // }
      // console.log(`%cprinterId_x:`, 'color: #f00;', this.printer_x, this.shop_x.id, this.printer_x[this.shop_x.id], this.printerId_x)
    },
    // POS机选择
    readerSelect(item, index) {
      // console.log(`%creaderId_x:`, 'color: #f00;', this.reader_x, this.shop_x.id, this.reader_x[this.shop_x.id], this.readerId_x)
      // console.log(`%c选择的POS机:`, 'color: #f00;', item, item.location, item.stripeId)
      // if (item.status === 1) {
        if (this.sysEnv_x === 'hk') {
          this.reader_x[String(this.shop_x.id)] = item.ipAdress
          this.readerId_x_save(JSON.parse(JSON.stringify(this.reader_x)))
        } else if (this.sysEnv_x === 'us') {
          this.reader_x[String(this.shop_x.id)] = item.stripeId
          this.readerId_x_save(JSON.parse(JSON.stringify(this.reader_x)))
        }
        // this.readerId_x_save(item.stripeId)
        // this.$api.reader_change({ readerId: item.stripeId })
      // }
      // console.log(`%creaderId_x:`, 'color: #f00;', this.reader_x, this.shop_x.id, this.reader_x[this.shop_x.id], this.readerId_x)
    },
    // 返回首页
    navToHome() {
      // console.log(`%croute:`, 'color: #f00;', this.$route)
      if (
        (this.homePage_x === 'table' && this.currentRoute !== 'table')
        || (this.homePage_x === 'menu' && this.currentRoute !== 'menu')
      ) {
        this.$router.push(this.menus[0].route)
      }
    },

    // #region 打开钱箱
    openCashDrawer() {
      if (this.user_x.privilegeList.includes('sjzhgl_bdksjrxjgl')) {
        this.$refs.DialogCashDrawer.open()
      } else {
        this.$refs.DialogKey.open({
          onConfirm: this.$refs.DialogCashDrawer.open,
        })
      }
    },
    // #endregion

    // #region 右侧下拉框
    // 是否显示手动日期控制
    openDialogDate() {
      this.visibleUser = false
      this.$refs.DialogDateControl.open()
    },
    // 切换全屏
    toggloFullScreen() {
      this.visibleUser = false
      this._togglo_full_screen()
    },
    // 查看我的反馈
    navToFeedback() {
      this.visibleUser = false
      if (this.currentRoute !== 'feedback') {
        this.$router.push('feedback')
      }
    },
    // 锁屏
    navToLock() {
      this.visibleUser = false
      this.$router.push('/lock')
    },
    // 退出登录
    logout() {
      this.$confirm(this.$t('index.logoutConfirm')).then(r => {   
        this.$api.user_logout().then(res => {
          if (res.status === 0) {
            this.socket && this.socket.close()
            this.user_x_clear()
            this.bellRing_x_save(false)
            this.paytypes_x_save([])
            this.paytypes2_x_save([])
            this.$router.push('/login')
            // 退出后要讲标签页初始化
            // this.$store.commit('initTab')
            this.visibleUser = false
          } else { this._status(res) }
        })
      }).catch(r => {})
    },
    // #endregion

    // 删除触摸屏
    async delMonitor(item, index) {
      const _D = await this.delData('monitor', { id: item.id })
      if (_D) {
        this.monitorList.splice(index, 1)
        this.$refs.DialogDriveError.deviceStatusSearch()
      }
    },
    async initScene(sceneId) {
      const _R_scene = await this.getData('scene', {
        shopId: this.currentShopId,
        enable: true,
        // sceneAsMenu: false
      })
      this.$store.commit('scene_x_save', _R_scene)

      const _R_scene_normal = _R_scene.filter(x1 => !x1.sceneAsMenu)
      // console.log(`%c所有场景:`, 'color: #00f;', _R_scene)
      this.scenes = _R_scene_normal
      console.log(`%c已选择的场景ID:`, 'color: #f0f;', sceneId)

      // 如果选择过场景，就会有场景ID，否则请求当前场景，获得场景ID
      if (sceneId) {
        this.sceneId = sceneId
        this.sceneId_x_save(sceneId)

        // 在所有场景列表中筛选出当前勾选的场景,获取模式
        const ITEM_SCENE = _R_scene_normal.find(x => x.id === sceneId)
        if (ITEM_SCENE) {
          this.modelList_x_save(ITEM_SCENE.runModuleSceneList)
        }
        
        if (this.modelList_x.length) {
          // console.log(`%c已保存的模式列表:`, 'color: #f0f;', this.modelList_x)
          const ITEM_MODEL = this.modelList_x.find(x => x.type === 0)
          this.menuHandle(ITEM_MODEL)
        } else {
          this.menuHandle()
        }
      } else {
        this.getCurrentScene()
      }

    },
    // 获取 当前场景
    getCurrentScene(autoOnlyBendRead = false, id = this.currentShopId) {
      // 如果当前是餐桌页面，並且餐桌也没有打开对话框，需要定时请求当前场景
      const CHILD = this.$refs.child
      const FLAG1 = this.currentRoute === 'table' && CHILD && CHILD.$refs.DialogTableDetail && !CHILD.$refs.DialogTableDetail.isShowDialog
      // const FLAG2 = this.currentRoute === 'menu' && CHILD && !CHILD.orderData.id
      let FLAG2 = true
      if (this.currentRoute === 'menu' && CHILD) {
        if (
          CHILD.orderData.id
            || (CHILD.$refs.DialogError && CHILD.$refs.DialogError.isShowDialog)
            || (CHILD.$refs.DialogCombo && CHILD.$refs.DialogCombo.isShowDialog)
            || (CHILD.$refs.DialogSpec && CHILD.$refs.DialogSpec.isShowDialog)
            || (CHILD.$refs.DialogCusfood && CHILD.$refs.DialogCusfood.isShowDialog)
            || (CHILD.$refs.DialogTimefood && CHILD.$refs.DialogTimefood.isShowDialog)
            || (CHILD.$refs.DialogTimePicker && CHILD.$refs.DialogTimePicker.isShowDialog)
            || (CHILD.$refs.DialogRemark && CHILD.$refs.DialogRemark.isShowDialog)
        ) {
          FLAG2 = false
        }
      }

      console.log('FLAG1 || FLAG2', FLAG1 || FLAG2)
      if (FLAG1 || FLAG2) {
        return this.$api.current_scene_search({
          shopId: id,
          autoOnlyBendRead,
        }).then(res => {
          if (res.status == 0) {
            let _R = res.data
            // console.log(`%c当前场景+id:`, 'color: #00f;', _R, _R.id)
            _R.id === 0 && (_R.id = '')
            if (this.sceneId !== _R.id) {
              // #region 是用户手动切换过场景，导致场景不一致
              // if (this.isSceneChangeByUser && this.currentRoute === 'menu') {
              //   this.setTimer()
              //   return
              // }
              // #endregion

              this.sceneId = _R.id
              this.sceneId_x_save(_R.id)
              
              this.modelList_x_save(_R.runModuleSceneList)
              const ITEM_MODEL = _R.runModuleSceneList.find(x => x.type === 0)
              this.menuHandle(ITEM_MODEL)
            }
          } else { this._status(res) }
        })
      }
    },
    // 获取 权限
    async getPrivilege(id, menus) {
      const _R = await this.getData('privilege', { id })
      if (_R && _R.length) {
        const { privilegeList } = _R[0]
        this.user_x.privilegeList = privilegeList
        this.user_x_save(this.user_x)
        console.log(`%c权限:`, 'color: #f00;', privilegeList)
        if (privilegeList.includes('sjzhgl_bdckdpzt')) {
          menus.push({key:'shop',route:'shop',img:require('@/assets/icons/menu5.png')}) // 店铺营业状态
          // menus.splice(4, 0, {key:'shop',route:'shop',img:require('@/assets/icons/menu5.png')}) // 店铺营业状态
        }
      } else {
        // if (this.currentRoute !== 'login') {
          this.$alert(this.$t('index.notFindPrivilege'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.comfirm'),
            callback: action => {
              console.log(action)
              this.getPrivilege(id, menus)
            }
          })
        // }
      }
    },
    // 处理菜单
    async menuHandle(ITEM_MODEL) {
      console.log(`%cmenuHandle`, 'color: #00f;', )
      this.el_loading_x_save(true)
      let menus = []
      // console.log(1122334455, ITEM_MODEL && ITEM_MODEL.enable)
      if (ITEM_MODEL && ITEM_MODEL.enable) {
        menus = [
          {key:'home',route:'table',img:require('@/assets/icons/menu1.png')}, // 餐桌
          // {key:'home',route:'menu',img:require('@/assets/icons/menu1.png')}, // 菜单
          {key:'lineup',route:'lineup',img:require('@/assets/icons/menu2.png')}, // 排队管理
          {key:'order',route:'order',img:require('@/assets/icons/menu3.png')}, // 订单管理
          // {key:'items',route:'items',img:require('@/assets/icons/menu4.png')}, // 菜品管理
          // {key:'shop',route:'shop',img:require('@/assets/icons/menu5.png')}, // 店铺营业状态
          // {key:'takeaway',route:'takeaway',img:require('@/assets/icons/menu6.png')}, // 外卖平台
          // {key:'qrcode',route:'qrcode',img:require('@/assets/icons/menu7.png')}, // 二维码管理
          // {key:'orderNew',route:'orderNew',img:require('@/assets/icons/menu9.png')}, // 落单审核
          // {key:'book',route:'book',img:require('@/assets/icons/menu10.svg')}, // 预定管理
          // {key:'member',route:'member',img:require('@/assets/icons/menu8.png')}, // 会员管理
        ]
        this.homePage_x_save('table')
        const CHILD = this.$refs.child
        if (this.currentRoute === 'menu' && CHILD && !CHILD.orderData.id) {
          this.$router.push('table')
        }
      } else {
        menus = [
          // {key:'home',route:'table',img:require('@/assets/icons/menu1.png')}, // 餐桌
          {key:'home',route:'menu',img:require('@/assets/icons/menu1.png')}, // 菜单
          {key:'lineup',route:'lineup',img:require('@/assets/icons/menu2.png')}, // 排队管理
          {key:'order',route:'order',img:require('@/assets/icons/menu3.png')}, // 订单管理
          // {key:'items',route:'items',img:require('@/assets/icons/menu4.png')}, // 菜品管理
          // {key:'shop',route:'shop',img:require('@/assets/icons/menu5.png')}, // 店铺营业状态
          // {key:'takeaway',route:'takeaway',img:require('@/assets/icons/menu6.png')}, // 外卖平台
          // {key:'qrcode',route:'qrcode',img:require('@/assets/icons/menu7.png')}, // 二维码管理
          // {key:'orderNew',route:'orderNew',img:require('@/assets/icons/menu9.png')}, // 落单审核
          // {key:'book',route:'book',img:require('@/assets/icons/menu10.svg')}, // 预定管理
          // {key:'member',route:'member',img:require('@/assets/icons/menu8.png')}, // 会员管理
        ]
        this.homePage_x_save('menu')
        const CHILD = this.$refs.child
        if (this.currentRoute === 'table' && CHILD && CHILD.$refs.DialogTableDetail && !CHILD.$refs.DialogTableDetail.isShowDialog) {
          this.$router.push('menu')
        }
      }

      // #region 库存管理
      if (this.shopConfig_m.inventoryEnable) {
        menus.push({key:'items',route:'items',img:require('@/assets/icons/menu4.png')}) // 菜品管理
      }
      // #endregion

      // #region 店铺营业状态
      const id = this.user_x.shopPrivilegeList[0] || ''
      // console.log(`%c用户权限id:`, 'color: #00f;', id)
      if (id) {
        await this.getPrivilege(id, menus)
      }
      // #endregion

      // #region 二维码管理
      menus.push({key:'qrcode',route:'qrcode',img:require('@/assets/icons/menu7.png')}) // 二维码管理
      // #endregion
      
      // #region 落单审核
      const res = await this.$api.orderNew_show({ shopId: this.currentShopId })
      // console.log(`%c是否显示审核:`, 'color: #f00;', res.data)
      let isShowOrderNew = res.data
      if (isShowOrderNew) {
        menus.push({key:'orderNew',route:'orderNew',img:require('@/assets/icons/menu9.png')}) // 落单审核
      }
      // #endregion

      // #region 预定管理
      if (this.shopConfig_m.bookEnable) {
        menus.push({key:'book',route:'book',img:require('@/assets/icons/menu10.svg')}) // 预定管理
      }
      // #endregion

      // #region 会员管理
      if (this.isShowMember) {
        menus.push({key:'member',route:'member',img:require('@/assets/icons/menu8.png')}) // 会员管理
      }
      // #endregion

      this.menus = menus
      this.el_loading_x_save(false)
    },

    bellClick() {
      this.bellOpen_x_save(true)
      let timer = setTimeout(() => {
        this.bellRing_x_save_once(true)
        clearTimeout(timer)
      }, 300)
      // return
      // // if (this.isDev) {
      //   this.$emit('playMusic')
      // // }
    },

    // 查询落单数量
    async waitingOrderSearch() {
      const _R = await this.getData('audit', {
        shopId: this.currentShopId,
        filterCheckoutOrderItem: true,
        status: 0,
      }, { back: true })
      this.menuCount_x.waitingOrderCount = _R
      this.menuCount_x_save(this.menuCount_x)
    },
    // 查询预定数量
    async waitingBookSearch(autoOnlyBendRead = false) {
      const today0 = new Date(new Date().toLocaleDateString()).getTime()
      const today24 = today0 + 24 * 60 * 60 * 1000 - 1
      const _R = await this.getData('book', {
        shopId: this.currentShopId,
        pageSize: 1,
        // status: 0,
        // startTime: today0,
        endTime: today24,
        status: 1,
        autoOnlyBendRead,
      }, { back: true })
      this.menuCount_x.waitingBookCount = _R
      this.menuCount_x_save(this.menuCount_x)
    },
    // 查询菜品售罄
    async itemsSellOutSearch(autoOnlyBendRead = false) {
      const _R = await this.getData('item', {
        shopId: this.currentShopId,
        online: true,
        saleOut: true,
        autoOnlyBendRead,
      }, { back: true })
      this.menuCount_x.itemsSellOutCount = _R
      this.menuCount_x_save(this.menuCount_x)
    },
    // 获取 打印机
    async getPrinter() {
      // console.log(`%c触发了查询打印机`, 'color: #00f;', )
      await this.$api.printer_search({
        shopId: this.currentShopId,
        online: true
      }).then(res => {
        if (res.status == 0) {
          let _R_printer = res.data
          // console.log(`%c打印机:`, 'color: #00f;', _R_printer)
          this.printerList = _R_printer
        } else { this._status(res) }
      })
    },
    // 获取 触摸屏
    async getMonitor() {
      // console.log(`%c触发了查询触摸屏`, 'color: #00f;', )
      const _R_monitors = await this.getData('monitor', { shopId: this.currentShopId })
      // console.log(`%c触摸屏:`, 'color: #00f;', _R_monitors)
      this.monitorList = _R_monitors
    },
    // 获取 POS机
    async getReader() {
      // console.log(`%c触发了查询POS机`, 'color: #00f;', )
      if (this.sysEnv_x === 'us') {
        const _R_reader = await this.getData('reader', { shopId: this.currentShopId })
        console.log(`%cPOS机US:`, 'color: #f00;', _R_reader)
        this.readerList = _R_reader
      } else if (this.sysEnv_x === 'hk') {
        const _R_reader = await this.getData('eftReader', {
          shopId: this.currentShopId,
          payTerminalType: 1,
        })
        console.log(`%cPOS机HK:`, 'color: #f00;', _R_reader)
        this.readerList = _R_reader
      }
    },
    async init() {
      // 初始化 场景
      this.initScene()
      // 刷新店铺状态（营业状态，手动控制日期）
      this.getShopData()

      // 获取 菜品售罄
      this.itemsSellOutSearch()
      // // 获取 设备状态
      // this.$refs.DialogDriveError.deviceStatusSearch()
      // 获取 打印机
      this.getPrinter()
      // 获取 触摸屏
      this.getMonitor()
      // 获取 POS机
      this.getReader()
      // 获取 落单数量
      this.waitingOrderSearch()
      // 获取 预定数量
      this.waitingBookSearch()
    },

    setTimer() {
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(async () => {
        if (await this.getUserLoginStatus()) {
          this.getCurrentScene(true)
          this.$refs.DialogDriveError && this.$refs.DialogDriveError.deviceStatusSearch(true)
          this.itemsSellOutSearch(true)
          // this.waitingOrderSearch() // 改为服务器ws通知
          this.waitingBookSearch(true)
        } else {
          this.timer && clearInterval(this.timer)
        }
      }, 30000)
    },
  },
  // async created() {
  //   if (this.currentShopId) {
  //     this.webSocket()
  //     this.init()

  //     this.initScanWatch()
  //   } else {
  //     this.$message.warning(this.$t('index.errorMessage'))
  //     this.$router.push('/login')
  //   }

    
    // // 登录⻚⾯创建完毕后，判断是否是Android Webview，并获取储存的⽤⼾名、密码
    // const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.loadCredentials, '')
    // console.log(`%c是否是Android Webview，并获取储存的⽤⼾名、密码:`, 'color: #f00;', RESULT)
    // if (RESULT) {
    //   // 隐藏“切换全屏”按钮
    //   vm.isShowFullBtn = false
    // }
  // },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 查询保存的uuid
      vm.UUID = localStorage.getItem('dola_uuid')
      // console.log(`%cUUID:`, 'color: #f00;', vm.UUID)

      // 读取登录页选择的语言
      vm.language = vm.$i18n.locale

      vm.setTimer()

      console.log('=============', vm.currentShopId)
      if (vm.currentShopId) {
        vm.webSocket()
        vm.init()

        vm.initScanWatch()
      } else {
        vm.$message.warning(vm.$t('index.errorMessage'))
        vm.$router.push('/login')
      }

      
      // 登录⻚⾯创建完毕后，判断是否是Android Webview，并获取储存的⽤⼾名、密码
      const RESULT = vm.$tool.dsbridge_call(vm.$tool.dsbridge_map.loadCredentials, '')
      console.log(`%c是否是Android Webview，并获取储存的⽤⼾名、密码:`, 'color: #f00;', RESULT)
      if (RESULT) {
        // 隐藏“切换全屏”按钮
        vm.isShowFullBtn = false
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.timer && clearInterval(this.timer)
    this.sceneId = ''
    this.closeWs()
    next()
  },
}
</script>

<style lang="scss" scoped>
// @import '@/assets/css/element.scss';
.el-container{
  .el-header{padding:0;height:60px;background: #374978;z-index: 10;}
  .content{
    height: calc(100% - 120px);
    // min-height: 600px;
    .el-aside{height: 100%;background: #374978;position: relative;}
    .el-aside>ul{height: calc(100% - 120px);}
    .el-main{flex:1;background-color:#f1f1f1;padding:0;overflow: hidden scroll;background: #F1F1F1;}
  }
}

.system-name{
  height: 60px;line-height: 24px;text-align: center;font-size: 14px;word-break: keep-all;
}

.el-aside{
  /deep/.el-submenu__title, .el-menu-item{font-size: 18px;}
  /deep/.is-active{background: #5F6D93!important;position: relative;}
  /deep/.el-menu-item::before{content: '';display: inline-block;width: 2px;height: 100%;position: absolute;left: 0;transition: background-color .3s;}
  /deep/.el-menu-item.is-active::before{background: #fff;}
  /deep/.el-submenu__title + .el-menu .el-menu-item{font-size: 14px;}
  .el-menu{border: none;}
  /deep/.el-menu-item i::before {color: #fff;}

  // /deep/.el-menu-item{display: flex;align-items: center;}
  // /deep/.el-tooltip{display: flex!important;align-items: center;}
  // .menu-icon-box{width: 24px;height: 24px;}
    
  // 折疊
  .el-menu-vertical-demo:not(.el-menu--collapse) {width: 180px;min-height: 400px;}
  // .el-radio-group {width: 56px;margin-bottom: 20px;position: absolute;bottom: 0;}
  // .toggle-aside-style-btn {height: 40px;line-height: 40px;z-index: 10;text-align: center;color: #fff;font-size: 20px;}
  .bell-box{
    .bell{width: 40px;height: 40px;margin: 10px 12px;}
  }
  .feedback-box{
    min-width: 64px;max-width: 100%;
    .feedback-btn{height: 40px;line-height: 20px;z-index: 10;color: #fff;padding: 0 8px;}
    .feedback-btn-collapse{text-align: center;}
  }
}

.header{
  .avatar{width:40px;height:40px;object-fit: contain;}
  .circle{border-radius:50%;}
  li.nickname{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 200px;text-align: right;}
  .open-btn{width: 100px;height: 30px;line-height: 30px;text-align: center;background: #fff;border-radius: 4px;margin-left: 17px;}
  /deep/input{background: transparent;padding-left: 0;border: none;color: #fff;font-size: 14px;text-align: center;}
  /deep/.el-icon-arrow-up{font-size: 14px;color: #fff;}
  li .logo{width: 60px;height: 60px;margin: 0 10px;}
}

// 设备报错
.shorter{height: calc(100% - 40px);}
.tip-error{
  height: 0;line-height: 40px;padding: 0 15px;box-sizing: border-box;
  background: #F0E9DB;overflow: hidden;border-bottom: 0 solid #F3D8A4;
  &.tip-error-show{height: 40px;border-bottom: 1px solid #F3D8A4;}
}

// 紅點
.red-dot1{
  position: relative;
  &::after {
    content: attr(data-num);display: inline-block;
    width: 28px;height: 28px;line-height: 28px;text-align: center;
    border-radius: 50%;font-size: 12px;
    background: #EA4646;position: absolute;top: 0;margin-left: 4px;
  }
}
.red-dot2{
  position: relative;
  &::after {
    content: '';display: inline-block;width: 8px;height: 8px;border-radius: 50%;
    background: #EA4646;position: absolute;top: 4px;right: 0;
  }
}
.dot /deep/.el-badge__content{background: #EA4646;border: 0;bottom: 0;margin: auto;right: 10px;}

// 氣泡框
.popper-btn{
  &.popper-btn-user{padding: 0 10px 0 20px;}
  .popper-icon{height: 100%;width: 25px;text-align: center;line-height: 28px;}
}
.popper-content{
  .item{text-align: center;height: 36px;line-height: 36px;}
  .item.ac{background-color: #F5F7FA;color: #374978;font-weight: 700;}
}
.popper-printer{
  padding: 20px;max-height: calc(84px * 4);overflow-y: scroll;
  .part{min-height: 84px;}
  .label{height: 84px;width: 70px;margin-right: 20px;word-break: keep-all;}
  .items{flex: 1;}
  .item{width: 33%;height: 84px;padding: 0 30px 0px 0;box-sizing: border-box;position: relative;}
  .item>div{line-height: 24px;}
  .tip1{width: 100px;height: 18px;line-height: 18px;text-align: center;}
  .tip2{
    width: 54px;height: 16px;line-height: 16px;text-align: center;
    color: #666;border: 1px solid #999;
  }
  .close-btn{width:20px;height:20px;position: absolute;top: 0;right: 40px;}

  // 选中的打印机
  .item-ac::after {
    content: '';display: inline-block;width: 20px;height: 20px;
    position: absolute;right: 40px;top: 10px;
    background: url('../../assets/icons/gou-ok2.png') no-repeat center center;
    background-size: contain;
  }
  // 本机
  .tip0{position: absolute;}
}
</style>